import cx from 'classnames';

import { ReactComponent as Check } from 'assets/icons/Check.svg';

interface WorkspaceRowCheckProps {
  isSelected: boolean;
  className?: string;
}

const WorkspaceRowCheck = ({ isSelected, className }: WorkspaceRowCheckProps) => (
  <Check
    className={cx('w-5 h-5 shrink-0 stroke-1.5', isSelected ? 'stroke-primary-70' : 'stroke-gray-30', className)}
  />
);

export default WorkspaceRowCheck;
